import {
  LanguageString,
  PageConfig,
  PageConfigComponentsGetter,
} from '../../../../common/components/dashboards/types';
import { TimeSliderTypes } from '../../../../common/components/timeslider/types';
import {
  getGrossProfitPerHeadByOrganizationChartConfig,
  getGrossProfitPerHeadOverTimeChartConfig,
  getKeyTalentAttritionByOrganizationChartConfig,
  getKeyTalentAttritionOverTimeChartConfig,
  getOvertimeWorkOverTimeChartConfig,
  getRemoteWorkDayOverTimeChartConfig,
  getTenureInJobGradeFactboxConfig,
  getTrainingInvestmentPerHeadByOrganizationChartConfig,
  getTrainingUtilizationByOrganizationChartConfig,
  getWorkforceFulfillmentRateFactboxConfig,
} from './human-capital-management-chart-helpers';

export const getWashiValueAddedProductivityDbPageConfig = (pageOption: {
  pageId: number;
  dashboardId: string;
  title: LanguageString;
}): PageConfig => {
  const { pageId, dashboardId, title } = pageOption;
  const pageComponents: PageConfigComponentsGetter = ({
    storyboardDateUtils,
    domainPreferences,
  }) => [
    getGrossProfitPerHeadOverTimeChartConfig(
      storyboardDateUtils,
      domainPreferences
    ),
    getKeyTalentAttritionOverTimeChartConfig(
      storyboardDateUtils,
      domainPreferences
    ),
    getGrossProfitPerHeadByOrganizationChartConfig(
      storyboardDateUtils,
      domainPreferences
    ),
    getKeyTalentAttritionByOrganizationChartConfig(
      storyboardDateUtils,
      domainPreferences
    ),
  ];

  const pageConfig: PageConfig = {
    pageId: pageId.toString(),
    dashboardId,
    pageNumber: pageId,
    enabled: true,
    title,
    pageOptions: {
      displayOptions: {
        enabled: true,
      },
      timeOptions: {
        timeSliderEnabled: true,
        timeSliderType: TimeSliderTypes.POINT,
      },
      filterTray: {
        enabled: false,
      },
      dataView: {
        enabled: false,
      },
      segmentationLevel1: {
        enabled: false,
      },
      segmentationLevel2: {
        enabled: false,
      },
      benchmark: {
        enabled: false,
      },
      forecast: {
        enabled: false,
      },
    },
    gridCols: 2,
    gridRows: 2,
    configType: 'componentConfigs',
    components: pageComponents,
    header: `- 目的：人的資本の独自性（変革実行力・柔軟性・長期志向）が**粗利と人材成果に結びついているか**を、月次で検証
- 今月のハイライト：A事業の1人あたり粗利が前年同期比▲20%と低下。加えて、**ハイパフォーマー離職率の改善が最優先課題**
`,
    footer: `- （脚注1）「ハイパフォーマー」＝最新評価サイクルで評価1,2の社員。派遣/業務委託は除外。
- （脚注2）外部出向中の従業員は集計対象外`,
  };
  return pageConfig;
};

export const getWashiHumanCapitalUniquenessDbPageConfig = (pageOption: {
  pageId: number;
  dashboardId: string;
  title: LanguageString;
}): PageConfig => {
  const { pageId, dashboardId, title } = pageOption;
  const pageComponents: PageConfigComponentsGetter = ({
    storyboardDateUtils,
    domainPreferences,
  }) => [
    getWorkforceFulfillmentRateFactboxConfig(
      storyboardDateUtils,
      domainPreferences
    ),
    getRemoteWorkDayOverTimeChartConfig(storyboardDateUtils, domainPreferences),
    getTrainingInvestmentPerHeadByOrganizationChartConfig(
      storyboardDateUtils,
      domainPreferences
    ),
    getTenureInJobGradeFactboxConfig(storyboardDateUtils, domainPreferences),
    getOvertimeWorkOverTimeChartConfig(storyboardDateUtils, domainPreferences),
    getTrainingUtilizationByOrganizationChartConfig(
      storyboardDateUtils,
      domainPreferences
    ),
  ];

  const pageConfig: PageConfig = {
    pageId: pageId.toString(),
    dashboardId,
    pageNumber: pageId,
    enabled: true,
    title,
    pageOptions: {
      displayOptions: {
        enabled: true,
      },
      timeOptions: {
        timeSliderEnabled: true,
        timeSliderType: TimeSliderTypes.POINT,
      },
      filterTray: {
        enabled: true,
      },
      dataView: {
        enabled: false,
      },
      segmentationLevel1: {
        enabled: false,
      },
      segmentationLevel2: {
        enabled: false,
      },
      benchmark: {
        enabled: false,
      },
      forecast: {
        enabled: false,
      },
    },
    gridCols: 3,
    gridRows: 2,
    configType: 'componentConfigs',
    components: pageComponents,
  };
  return pageConfig;
};
